module.exports = __webpack_public_path__ + "static/fonts/LcdD.048ff21.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/comment/font/LcdD.ttf
// module id = 0xey
// module chunks = 133